import { useState } from "react";
import { Button, CircularProgress, TextField, Typography } from "@mui/material";
import { Link, useParams, useHistory } from "react-router-dom";
import BoxedLayout from "../components/common/BoxedLayout";
import { useFormik } from "formik";
import * as yup from "yup";
import { requestNewPassword} from "../services/dataService"; // Add verifyOtp API
import { Verifychangepasscode,ResendPasscode } from "../services/authService";
import { toast } from "react-toastify";

const ForgotPasswordSubmit = () => {
  const { email: userEmail } = useParams();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);  
  const [resendLoading, setResendLoading] = useState(false);
const [resendDisabled, setResendDisabled] = useState(false);
const [resendTimer, setResendTimer] = useState(0);


 const handleOtpVerification = async (otp) => {
  setLoading(true);
  try {
    const response = await Verifychangepasscode(userEmail, otp);
    

    const data = response?.data;

    if (data=== "OTP verified successfully.") {
      toast.success("OTP verified successfully.");
      setOtpVerified(true);
    } else {
      toast.error(data?.message || "Invalid OTP.");
    }
  } catch (error) {
    console.error("Verification error:", error);
    toast.error("OTP verification failed.");
  } finally {
    setLoading(false);
  }
};
const handleResendOtp = async () => {
  setResendLoading(true);
  try {
    await ResendPasscode(userEmail);
    toast.success("OTP resent successfully.");

    setResendDisabled(true);
    setResendTimer(30); // Start countdown from 30 seconds

    const timerInterval = setInterval(() => {
      setResendTimer((prev) => {
        if (prev === 1) {
          clearInterval(timerInterval);
          setResendDisabled(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  } catch (error) {
    console.error("Resend OTP error:", error);
    toast.error("Failed to resend OTP.");
  } finally {
    setResendLoading(false);
  }
};





  const handleResetPassword = async (values) => {
    try {
      setLoading(true);
      await requestNewPassword({
        PassCode: values.PassCode,
        email: userEmail,
        newPassword: values.newPassword,
      });
      toast.success("Password reset successful.");
      history.push("/");
    } catch (error) {
      toast.error("Unable to update password");
    } finally {
      setLoading(false);
    }
  };

  const validationSchema = yup.object({
    PassCode: yup.string().required("OTP is required"),
    newPassword: otpVerified ? yup.string().required("Password is required") : yup.string(),
    confirmPassword: otpVerified
      ? yup
          .string()
          .required("Confirm Password is required")
          .oneOf([yup.ref("newPassword")], "Passwords must match")
      : yup.string(),
  });

  const formik = useFormik({
    initialValues: {
      PassCode: "",
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema,
    onSubmit: (values) => {
      if (!otpVerified) {
        handleOtpVerification(values.PassCode);
      } else {
        handleResetPassword(values);
      }
    },
  });

  return(
    <BoxedLayout>
      <Typography component="h1" variant="h5">
        Change your password
      </Typography>

      <Typography marginTop={3}>
        {otpVerified
          ? "OTP verified. Please set your new password below."
          : "Enter the OTP you received via E-mail to verify your identity."}
      </Typography>

      <form onSubmit={formik.handleSubmit}>
     {!otpVerified && (
  <>
  <div style={{ position: "relative", width: "100%", marginBottom: "20px" }}></div>
    <TextField
      fullWidth
      margin="normal"
      id="PassCode"
      name="PassCode"
      label="OTP Code"
      value={formik.values.PassCode}
      onChange={formik.handleChange}
      error={formik.touched.PassCode && Boolean(formik.errors.PassCode)}
      helperText={formik.touched.PassCode && formik.errors.PassCode}
    />
 
  <Button
  variant="text"
  onClick={handleResendOtp}
  disabled={resendLoading || resendDisabled}
  sx={{ mt: 1, mb: 2 }}
>
  {resendLoading ? (
    <CircularProgress size={20} />
  ) : resendDisabled ? (
    `Resend OTP in ${resendTimer}s`
  ) : (
    "Resend OTP"
  )}
</Button>

  </>
)}



        {otpVerified && (
          <>
            <TextField
              fullWidth
              margin="normal"
              id="newPassword"
              name="newPassword"
              label="New Password"
              type="password"
              value={formik.values.newPassword}
              onChange={formik.handleChange}
              error={
                formik.touched.newPassword &&
                Boolean(formik.errors.newPassword)
              }
              helperText={
                formik.touched.newPassword && formik.errors.newPassword
              }
            />

            <TextField
              fullWidth
              margin="normal"
              id="confirmPassword"
              name="confirmPassword"
              label="Confirm Password"
              type="password"
              value={formik.values.confirmPassword}
              onChange={formik.handleChange}
              error={
                formik.touched.confirmPassword &&
                Boolean(formik.errors.confirmPassword)
              }
              helperText={
                formik.touched.confirmPassword &&
                formik.errors.confirmPassword
              }
            />
          </>
        )}

        <Button
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
          size="large"
          sx={{ mt: 3 }}
        >
          {otpVerified ? "Reset Password" : "Verify OTP"}
        </Button>
      </form>

      <Button
        component={Link}
        to="/"
        color="primary"
        fullWidth
        size="large"
        sx={{ mt: 2 }}
      >
        Back to login
      </Button>
    </BoxedLayout>
  );
};

export default ForgotPasswordSubmit;
